import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getCommunityTemplatesList } from "../../../../store/actions/ask";
import { FormattedMessage } from "react-intl";
import CommunityTemplatesFilters from "./communityTemplatesFilters";
import CommunityTemplatesList from "./communityTemplatesList";
import useFilterAndSorterTemplates from "./useFilterAndSorterTemplates";
import "../style.css";
import LoaderSimple from "../../../general/loader";
import CommunityTemplatesSearch from "./communityTemplatesSearch";
import CommunityTemplatesOrderSelect from "./communityTemplatesOrderSelect";
import { useOrderTemplates } from "../../../../customHooks";
import { useIntl } from "react-intl";

const CommunityTemplates = () => {
  const intl = useIntl();
  const [categoryFilterValue, setCategoryFilterValue] = useState(null);
  const [authorFilterValue, setAuthorFilterValue] = useState(null);
  const [ratingFilterValue, setRatingFilterValue] = useState(null);
  const [dateSortingOrder, setDateSortingOrder] = useState("desc");
  const [templatesToShow, setTemplatesToShow] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [orderByDate, setOrderByDate] = useState(true);
  const [orderAlphabetically, setOrderAlphabetically] = useState(false);
  const [orderAlphabeticallyReverse, setOrderAlphabeticallyReverse] = useState(false);
  const auth = useSelector(state => state.auth);
  const accountantUuidSelected = useSelector(state=>state.main.accountantUuidSelected);
  const communityTemplates = useSelector(state => state.ask.communityTemplates);
  const isGettingCommunityTemplatesList = useSelector(state => state.ask.communityTemplates.isGettingCommunityTemplates);
  const templates = communityTemplates.templatesList.filter(templ => templ.authorActions !== null);

  const templatesAuthorsRaw = templates.map(t => t.authorName);
  const templatesCategoriesRaw = templates.map(t => t.category);
  const templatesRatingsRaw = templates.map(t => t.score);

  const templatesAuthorsFiltered = [...new Set(templatesAuthorsRaw)];
  const templatesCategoriesFiltered = [...new Set(templatesCategoriesRaw)];
  const templatesRatingsFiltered = [...new Set(templatesRatingsRaw)];

  const templatesAuthors = [intl.formatMessage({ id: "all"}), ...templatesAuthorsFiltered];
  const templatesCategories = ["Tutte", ...templatesCategoriesFiltered];
  const templatesRatings = [intl.formatMessage({ id: "all"}), ...templatesRatingsFiltered];

  const dispatch = useDispatch();

  const templatesFilteredAndSorted = useFilterAndSorterTemplates(
    categoryFilterValue, authorFilterValue, ratingFilterValue, templates
  );

  useEffect(() => {
    dispatch(getCommunityTemplatesList());
  }, [auth, accountantUuidSelected]);

  useEffect(() => {
    setTemplatesToShow((templatesFilteredAndSorted.length > 0) ||
				((templatesFilteredAndSorted.length === 0) &&
					(categoryFilterValue !== null || authorFilterValue !== null || ratingFilterValue !== null)) ?
      templatesFilteredAndSorted
      : templates);
  }, [templatesFilteredAndSorted, categoryFilterValue, authorFilterValue, ratingFilterValue, communityTemplates]);

  const changeCategories = value => {
    setCategoryFilterValue(value !== "Tutte" ? value : null);
  };

  const changeAuthors = value => {
    setAuthorFilterValue(value !== intl.formatMessage({ id: "all"}) ? value : null);
  };

  const changeRatings = value => {
    setRatingFilterValue(value !== intl.formatMessage({ id: "all"}) ? +value : null);
  };

  const onDateSorting = () => {
    setDateSortingOrder(dateSortingOrder === "desc" ? "asc" : "desc");
  };

  const editSearchTerm = e => {
    setSearchTerm(e.target.value);
  };

  const searchedTemplates = templatesToShow.filter(templ => templ.name.toLowerCase().includes(searchTerm.toLowerCase()));

  const orderedTemplates = useOrderTemplates(
    searchedTemplates, orderByDate, orderAlphabetically, orderAlphabeticallyReverse, "name"
  );

  return (
    <>
      <section className="headerContainer">
			  <div className="titleContainer">
			    <h4 className="askEdit-chooseTemplate-title">
			      <FormattedMessage id="ask.pages.edit.communityTemplates.title" />
			    </h4>
			    <h5 className="communityTemplatesSubtitle">
			      <FormattedMessage id="ask.pages.edit.communityTemplates.subtitle" />
			    </h5>
			  </div>
			  <div className="communityTemplatesOrderBy">
			    <CommunityTemplatesOrderSelect
			      setOrderByDate={setOrderByDate}
			      setOrderAlphabetically={setOrderAlphabetically}
			      setOrderAlphabeticallyReverse={setOrderAlphabeticallyReverse}
			    />
			  </div>
      </section>
      <section className="communityTemplatesList">
			  <h4 className="communityTemplatesTitle"><FormattedMessage id="ask.pages.edit.communityTemplates.sectionTitle" /></h4>
			  <div className="communityTemplatesOuterContainer">
			    <div className="communityTemplatesFilterSection">
			      <CommunityTemplatesSearch
			        editSearchTerm={editSearchTerm}
			        searchTerm={searchTerm}
			      />
			      <CommunityTemplatesFilters
			        changeCategories={changeCategories}
			        changeAuthors={changeAuthors}
			        changeRatings={changeRatings}
			        onDateSorting={onDateSorting}
			        dateSortingOrder={dateSortingOrder}
			        templatesCategories={templatesCategories}
			        templatesAuthors={templatesAuthors}
			        templatesRatings={templatesRatings}
			      />
			    </div>
			    {!isGettingCommunityTemplatesList ?
			      (<CommunityTemplatesList
			        templatesToShow={orderedTemplates}
			        auth={auth}
			        accountantUuidSelected={accountantUuidSelected}
			      />)
			      : (
			        <div className="communityTemplatesLoaderContainer">
			          <LoaderSimple />
			        </div>
			      )
			    }
			  </div>

      </section>
    </>
  );
};

export default CommunityTemplates;